import OGuideQrCode from './o-guide-qr-code';

export default OGuideQrCode;